<template>
  <div id="fuentefinanciera-toolbar-fuentefinanciera">
    <v-toolbar
      class="mb-2"
      flat>
      <v-toolbar-title
        class="display-1">
        Fuentes Financieras
      </v-toolbar-title>
    </v-toolbar>
  </div>
</template>

<script>
export default {

};
</script>

<style>

</style>
